<div id="chatContainer" class="chat-box-container">
  <div>
    <div class="chat-box-nav animated fadeInRight">
      <div class="title-div">
        <!-- <a class="welcomeBack" (click)="showWelcomeScreen()">-->
        <img style="width:2em;margin-right:10px;" class="" src="assets/image/ocio_logo/ocio_white_logo@2x.png">
        <!--</a> -->
        <label style="vertical-align: text-bottom;">{{title}}</label>
      </div>
      <!-- <div class="fontsize">
        <button class="btn btn-white-sm" (click)="changeFontsize('large')">
          <p style="font-size:18px; margin:0;">A</p>
        </button>
        <button class="btn btn-white-sm" (click)="changeFontsize('medium')">
          <p style="font-size:14px; margin:0;">A</p>
        </button>
        <button class="btn btn-white-sm" (click)="changeFontsize('small')">
          <p style="font-size:10px; margin:0;">A</p>
        </button>
      </div> -->
    </div>
    <div class="chat-box-content bubble-container" style="background-color: transparent;">
      <div *ngIf="chats.length" #scrollMe class="bubble-wrap" [scrollTop]="scrolltop">
        <div *ngFor="let chat of chats; let c = index">

          <div *ngIf="chat.isUser" class="bubble say reply">
            <div *ngIf="chat.type === 'text'; else attachmentData">
              <span class="bubble-content animated fadeInRight">
                <span [(ngClass)]="fontsizeClass" class="bubble-button" [innerHTML]="chat.info | emojis"> </span>
              </span>
            </div>
            <ng-template #attachmentData>
              <span class="bubble-content animated fadeInRight">
                <span [(ngClass)]="fontsizeClass" class="bubble-button">
                  <a target="_blank" [href]="chat.path" [download]="chat.info">
                    <i class="fa fa-paperclip" aria-hidden="true"></i> {{chat.info}}
                  </a>
                </span>
              </span>
            </ng-template>
          </div>

          <div *ngIf="!chat.isUser">
            <div *ngIf="chat.type === 'text'">
              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated {{chat.style}}">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                  <div *ngIf="chat.text === null && chat.rating !== null" class="container">
                    <div *ngIf="chat.rating?.type !== undefined">
                      <div *ngIf="chat.rating.type === 'star'">
                        <rating [(ngModel)]="chat.rating.value" (click)="ratingChanged(chat.rating)"></rating>
                      </div>
                      <div *ngIf="chat.rating.type === 'thumb'" class="contentRight">
                        <button class="like" [style.color]="color1" (click)="thumbsClicked(chat.rating, 'like')"> <i
                            class="far fa-thumbs-up" aria-hidden="true"></i> </button>
                        <button class="dislike" [style.color]="color2" (click)="thumbsClicked(chat.rating, 'dislike')">
                          <i class="far fa-thumbs-down" aria-hidden="true"></i> </button>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
              <div *ngIf="chat.text !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated {{chat.style}}">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.text | linky"> </span>
                  <div *ngIf="chat.rating !== null" class="container">
                    <div *ngIf="chat.rating?.type !== undefined">
                      <div *ngIf="chat.rating.type === 'star'">
                        <rating [(ngModel)]="chat.rating.value" (click)="ratingChanged(chat.rating)"></rating>
                      </div>
                      <div *ngIf="chat.rating.type === 'thumb'" class="contentRight">
                        <button class="like" [style.color]="color1" (click)="thumbsClicked(chat.rating, 'like')"> <i
                            class="far fa-thumbs-up" aria-hidden="true"></i> </button>
                        <button class="dislike" [style.color]="color2" (click)="thumbsClicked(chat.rating, 'dislike')">
                          <i class="far fa-thumbs-down" aria-hidden="true"></i> </button>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>

            <div *ngIf="chat.type === 'image'">
              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated {{chat.style}}">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated {{chat.style}}">
                  <div class="card noBorder">
                    <a (click)="openInNewTab(chat.webUrl)">
                      <img class="thumb-img" [src]="chat.imageUrl" alt="">
                    </a>
                  </div>
                  <div *ngIf="chat.rating !== null" class="container">
                    <div *ngIf="chat.rating?.type !== undefined">
                      <div *ngIf="chat.rating.type === 'star'">
                        <rating [(ngModel)]="chat.rating.value" (click)="ratingChanged(chat.rating)"></rating>
                      </div>
                      <div *ngIf="chat.rating.type === 'thumb'" class="contentRight">
                        <button class="like" [style.color]="color1" (click)="thumbsClicked(chat.rating, 'like')"> <i
                            class="far fa-thumbs-up" aria-hidden="true"></i> </button>
                        <button class="dislike" [style.color]="color2" (click)="thumbsClicked(chat.rating, 'dislike')">
                          <i class="far fa-thumbs-down" aria-hidden="true"></i> </button>
                      </div>
                    </div>
                  </div>
                </span>
              </div>

            </div>

            <div *ngIf="chat.type === 'quick_replies'">
              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div *ngIf="chat.text !== ''" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content">
                  <span *ngIf="chat.text !== null" [(ngClass)]="fontsizeClass" class="chat"
                    [innerHTML]="chat.text | linky"></span>
                  <div *ngIf="chat.buttons && chat.buttons.length" class="quick-reply-wrapper animated {{chat.style}}">
                    <owl-carousel [options]="timerOptions">
                      <a *ngFor="let qr of chat.buttons" [(ngClass)]="fontsizeClass" class="btn-white-sm btn"
                        (click)="onClick(qr, c, false)">
                        {{qr.title}} </a>
                    </owl-carousel>
                  </div>
                </span>
              </div>
            </div>

            <div *ngIf="chat.type === 'buttons'">
              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div *ngIf="chat.buttons && chat.buttons.length" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content">
                  <div class="quick-reply-wrapper animated {{chat.style}}">
                    <!-- <owl-carousel [options]="timerOptions"> -->
                      <a *ngFor="let qr of chat.buttons" [(ngClass)]="fontsizeClass" class="btn-white-sm btn"
                        (click)="onClick(qr, c, false)">
                        {{qr.title}} </a>
                    <!-- </owl-carousel> -->
                  </div>
                </span>
              </div>
            </div>

            <div *ngIf="chat.type === 'dropdown'">

              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated {{chat.style}}">
                  <div class="dropdown">
                    <button (click)="showDropDown(c)" class="dropbtn" [disabled]="chat.disabled"
                      [ngClass]="{ 'cursor-prevent': chat.disabled}">
                      {{chat.title}} </button>

                    <div id="myDropdown" class="dropdown-content dropdown-demo" [ngClass]="{'show': chat.showDropdown}">
                      <a *ngFor="let opt of chat.options" (click)="onClick(opt, c, true)">{{opt.title}}</a>
                    </div>
                  </div>
                </span>
              </div>
            </div>

            <div *ngIf="chat.type === 'card'">

              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content animated {{chat.style}}">
                  <div class="carousel-card">
                    <div class="icon">
                      <img [src]="chat.card.icon" alt="">
                    </div>
                    <div class="text-wrap">
                      <p [(ngClass)]="fontsizeClass" class="mt-0 mb-0" [innerHTML]="chat.card.title"></p>
                      <!-- <p [(ngClass)]="fontsizeClass" class="mt-2" [innerHTML]="chat.card.subtitle"></p> -->
                    </div>
                    <img class="thumb-img" [src]="chat.card.image_url" alt="">
                    <div *ngIf="chat.card.buttons && chat.card.buttons.length" class="btn-wrap">
                      <a *ngFor="let cardBtn of chat.card.buttons" [(ngClass)]="fontsizeClass" class="btn-white-sm btn"
                        (click)="onClick(cardBtn, null, false)">
                        {{cardBtn.title}} </a>
                    </div>
                  </div>
                  <div *ngIf="chat.rating !== null" class="container">
                    <div *ngIf="chat.rating?.type !== undefined">
                      <div *ngIf="chat.rating.type === 'star'">
                        <rating [(ngModel)]="chat.rating.value" (click)="ratingChanged(chat.rating)"></rating>
                      </div>
                      <div *ngIf="chat.rating.type === 'thumb'" class="contentRight">
                        <button class="like" [style.color]="color1" (click)="thumbsClicked(chat.rating, 'like')"> <i
                            class="far fa-thumbs-up" aria-hidden="true"></i> </button>
                        <button class="dislike" [style.color]="color2" (click)="thumbsClicked(chat.rating, 'dislike')">
                          <i class="far fa-thumbs-down" aria-hidden="true"></i> </button>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>

            <div *ngIf="chat.type === 'cards'">

              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div *ngIf="chat.cards && chat.cards.length" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <span class="bubble-content animated {{chat.style}}">
                  <div class="carousel-card-wrap">
                    <owl-carousel [options]="cardsOptions">
                      <div *ngFor="let cards of chat.cards" class="carousel-card">
                        <!-- <div class="icon">
                          <img [src]="cards.icon" alt="">
                        </div> -->
                        <div class="text-wrap">
                          <p [(ngClass)]="fontsizeClass" class="mt-0 mb-0" [innerHTML]="cards.title"> </p>
                          <!-- <p [(ngClass)]="fontsizeClass" class="mt-2" [innerHTML]="cards.subtitle"> </p> -->
                        </div>
                        <img class="thumb-img" [src]="cards.image_url" alt="">

                        <div *ngIf="cards.buttons && cards.buttons.length" class="btn-wrap">
                          <a *ngFor="let cBtn of cards.buttons" [(ngClass)]="fontsizeClass" class="btn-white-sm btn"
                            (click)="onClick(cBtn, null, false)">
                            {{cBtn.title}} </a>
                        </div>
                      </div>
                    </owl-carousel>
                  </div>
                </span>
              </div>
            </div>
            <div *ngIf="chat.type === 'list'">
              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="list-group animated {{chat.style}}">
                  <div *ngFor="let list of chat.elements; let l = index;" class="list-item">
                    <div class="left">
                      <h3 class="mt-0"> {{list.title}} </h3>
                      <p class="mt-0" [innerHTML]="list.subtitle"></p>
                      <div *ngIf="list.buttons && list.buttons.length">
                        <a *ngFor="let lBtn of list.buttons" class="btn btn-orange"
                          (click)="onClick(lBtn, null, false)">
                          {{lBtn.title}} </a>
                      </div>
                    </div>
                    <div class="right">
                      <img [src]="list.image_url" alt="">
                    </div>
                  </div>
                  <div *ngIf="chat.button && chat.button.length" class="list-item item-last">
                    <a *ngFor="let listBtn of chat.button" class="btn-white-sm btn quarter-width"
                      (click)="onClick(listBtn, null, false)">
                      {{listBtn.title}} </a>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'datepicker'">

              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="animated {{chat.style}}">
                  <air-datepicker [airOptions]="calendarOptions" [(airDate)]="selectedDate"
                    (airChange)="dateChanged($event)"></air-datepicker>
                </div>
              </div>

            </div>

            <div *ngIf="chat.type === 'droplist'">

              <div *ngIf="chat.info !== null" class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="logo">
                <span class="bubble-content animated pulse">
                  <span [(ngClass)]="fontsizeClass" class="chat" [innerHTML]="chat.info | linky"> </span>
                </span>
              </div>

              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="animated {{chat.style}}">
                  <div class="time-picker">
                    <div class="head">
                      <span> {{chat.title}} </span>
                    </div>
                    <div class="time-carousel">
                      <owl-carousel [options]="{dots: false, autoWidth: true, nav: true, loop: false}"
                        [carouselClasses]="['row']" [items]="chat.options">
                        <div *ngFor="let drOptions of chat.options; let dl =index" class="time-row"
                          [ngClass]="{'no-border': dl === chat.options.length - 1}">
                          <span class="location"> {{drOptions.title}} </span>
                          <span *ngFor="let dlBtn of drOptions.buttons" class="time">
                            <a (click)="onClick(dlBtn, null, false)"> {{dlBtn.title}} </a>
                          </span>
                        </div>
                      </owl-carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Templates for Comment forms -->

            <div *ngIf="chat.type === 'commentForm1'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #commentForm="ngForm" novalidate (ngSubmit)="submitComment(commentForm, chat)">
                    <div class="search-ans">
                      <textarea class="form-control" rows="3" placeholder="Comment here ..." name="comment"
                        [(ngModel)]="chat.formFields.comment" required #comment="ngModel"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Comment here ..." name="comment" [(ngModel)]="chat.formFields.comment"
                        required pattern="(.*\S.*)" #comment="ngModel"> -->
                      <button type="submit" class="btn btn-primary bh">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="comment.errors && (comment.touched || commentForm.submitted)" class="cardError">
                        <p *ngIf="comment?.errors.required">This field is required</p>
                        <p *ngIf="comment?.errors.pattern">Please enter your comment</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'commentForm2'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #commentForm1="ngForm" novalidate (ngSubmit)="submitComment(commentForm1, chat)">
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Name" name="name"
                        [(ngModel)]="chat.formFields.name" required pattern="(.*\S.*)" #name="ngModel">
                      <div *ngIf="name.errors && (name.touched || commentForm1.submitted)" class="cardError">
                        <p *ngIf="name?.errors.required">This field is required</p>
                        <p *ngIf="name?.errors.pattern">Please enter your name</p>
                      </div>
                    </div>
                    <div class="search-ans">
                      <textarea class="form-control" rows="3" placeholder="Comment here ..." name="comment1"
                        [(ngModel)]="chat.formFields.comment" required #comment1="ngModel"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Comment here ..." name="comment1"
                        [(ngModel)]="chat.formFields.comment" required pattern="(.*\S.*)" #comment1="ngModel"> -->
                      <button type="submit" class="btn btn-primary bh">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="comment1.errors && (comment1.touched || commentForm1.submitted)" class="cardError">
                        <p *ngIf="comment1?.errors.required">This field is required</p>
                        <p *ngIf="comment1?.errors.pattern">Please enter your comment</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'commentForm3'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #commentForm2="ngForm" novalidate (ngSubmit)="submitComment(commentForm2, chat)">
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Name" name="name1"
                        [(ngModel)]="chat.formFields.name" required pattern="(.*\S.*)" #name1="ngModel">
                      <div *ngIf="name1.errors && (name1.touched || commentForm2.submitted)" class="cardError">
                        <p *ngIf="name1?.errors.required">This field is required</p>
                        <p *ngIf="name1?.errors.pattern">Please enter your name</p>
                      </div>
                    </div>
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Email" name="email1"
                        [(ngModel)]="chat.formFields.email" required
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$" #email1="ngModel">
                      <div *ngIf="email1.errors && (email1.touched || commentForm2.submitted)" class="cardError">
                        <p *ngIf="email1?.errors.required">This field is required</p>
                        <p *ngIf="email1?.errors.pattern">Please enter a valid email</p>
                      </div>
                    </div>
                    <div class="search-ans">
                      <textarea class="form-control" rows="3" placeholder="Comment here ..." name="comment2"
                        [(ngModel)]="chat.formFields.comment" required #comment2="ngModel"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Comment here ..." name="comment2"
                        [(ngModel)]="chat.formFields.comment" required pattern="(.*\S.*)" #comment2="ngModel"> -->
                      <button type="submit" class="btn btn-primary bh">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="comment2.errors && (comment2.touched || commentForm2.submitted)" class="cardError">
                        <p *ngIf="comment2?.errors.required">This field is required</p>
                        <p *ngIf="comment2?.errors.pattern">Please enter your comment</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'commentForm4'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #commentForm3="ngForm" novalidate (ngSubmit)="submitComment(commentForm3, chat)">
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Name" name="name2"
                        [(ngModel)]="chat.formFields.name" required pattern="(.*\S.*)" #name2="ngModel">
                      <div *ngIf="name2.errors && (name2.touched || commentForm3.submitted)" class="cardError">
                        <p *ngIf="name2?.errors.required">This field is required</p>
                        <p *ngIf="name2?.errors.pattern">Please enter your name</p>
                      </div>
                    </div>
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Mobile number" name="mobile"
                        [(ngModel)]="chat.formFields.mobile" required pattern="(.*\S.*)" #mobile="ngModel">
                      <div *ngIf="mobile.errors && (mobile.touched || commentForm3.submitted)" class="cardError">
                        <p *ngIf="mobile?.errors.required">This field is required</p>
                        <p *ngIf="mobile?.errors.pattern">Please enter a valid mobile number</p>
                      </div>
                    </div>
                    <div class="search-ans">
                      <textarea class="form-control" rows="3" placeholder="Comment here ..." name="comment3"
                        [(ngModel)]="chat.formFields.comment" required #comment3="ngModel"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Comment here ..." name="comment3"
                        [(ngModel)]="chat.formFields.comment" required pattern="(.*\S.*)" #comment3="ngModel"> -->
                      <button type="submit" class="btn btn-primary bh">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="comment3.errors && (comment3.touched || commentForm3.submitted)" class="cardError">
                        <p *ngIf="comment3?.errors.required">This field is required</p>
                        <p *ngIf="comment3?.errors.pattern">Please enter your comment</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'commentForm5'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #commentForm4="ngForm" novalidate (ngSubmit)="submitComment(commentForm4, chat)">
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Name" name="name3"
                        [(ngModel)]="chat.formFields.name" required pattern="(.*\S.*)" #name3="ngModel">
                      <div *ngIf="name3.errors && (name3.touched || commentForm4.submitted)" class="cardError">
                        <p *ngIf="name3?.errors.required">This field is required</p>
                        <p *ngIf="name3?.errors.pattern">Please enter your name</p>
                      </div>
                    </div>
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Mobile number" name="mobile1"
                        [(ngModel)]="chat.formFields.mobile" required pattern="(.*\S.*)" #mobile1="ngModel">
                      <div *ngIf="mobile1.errors && (mobile1.touched || commentForm4.submitted)" class="cardError">
                        <p *ngIf="mobile1?.errors.required">This field is required</p>
                        <p *ngIf="mobile1?.errors.pattern">Please enter a valid mobile number</p>
                      </div>
                    </div>
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Email" name="email2"
                        [(ngModel)]="chat.formFields.email" required
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$" #email2="ngModel">
                      <div *ngIf="email2.errors && (email2.touched || commentForm4.submitted)" class="cardError">
                        <p *ngIf="email2?.errors.required">This field is required</p>
                        <p *ngIf="email2?.errors.pattern">Please enter a valid email</p>
                      </div>
                    </div>
                    <div class="search-ans">
                      <textarea class="form-control" rows="3" placeholder="Comment here ..." name="comment4"
                        [(ngModel)]="chat.formFields.comment" required #comment4="ngModel"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Comment here ..." name="comment4"
                        [(ngModel)]="chat.formFields.comment" required pattern="(.*\S.*)" #comment4="ngModel"> -->
                      <button type="submit" class="btn btn-primary bh">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="comment4.errors && (comment4.touched || commentForm4.submitted)" class="cardError">
                        <p *ngIf="comment4?.errors.required">This field is required</p>
                        <p *ngIf="comment4?.errors.pattern">Please enter your comment</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'subscriptionForm'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #subscriptionForm="ngForm" novalidate (ngSubmit)="submitComment(subscriptionForm, chat)">
                    <div class="search-ans mb5">
                      <input type="text" class="form-control" placeholder="Email" name="email3"
                        [(ngModel)]="chat.formFields.email" required
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$" #email3="ngModel">
                      <button type="submit" class="btn btn-primary">
                        <i class="far fa-paper-plane"></i>
                      </button>
                      <div *ngIf="email3.errors && (email3.touched || subscriptionForm.submitted)" class="cardError">
                        <p *ngIf="email3?.errors.required">This field is required</p>
                        <p *ngIf="email3?.errors.pattern">Please enter a valid email</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div *ngIf="chat.type === 'loginForm'">
              <div class="bubble say">
                <img class="brand-logo" [src]="logoUrl" alt="">
                <div class="formCard">
                  <h4> {{chat.title}} </h4>
                  <form #signinForm="ngForm" novalidate (ngSubmit)="submitComment(signinForm, chat)">
                    <div class="search-ans mb5">
                      <input type="text" name="username1" placeholder="Username" [(ngModel)]="chat.formFields.username"
                        required pattern="(.*\S.*)" #username1="ngModel">
                      <div *ngIf="username1.errors && (username1.touched || signinForm.submitted)" class="cardError">
                        <p *ngIf="username1?.errors.required">This field is required</p>
                        <p *ngIf="username1?.errors.pattern">Please enter a valid name</p>
                      </div>
                    </div>
                    <div class="search-ans">
                      <input type="password" name="password1" placeholder="Password"
                        [(ngModel)]="chat.formFields.password" required pattern="(.*\S.*)" #password1="ngModel">
                      <button type="submit" class="btn btn-primary">
                        <i class="fas fa-sign-in-alt"></i>
                      </button>
                      <div *ngIf="password1.errors && (password1.touched || signinForm.submitted)" class="cardError">
                        <p *ngIf="password1?.errors.required">This field is required</p>
                        <p *ngIf="password1?.errors.pattern">Please enter a valid password</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div *ngIf="loading" class="bubble say">
          <div class="bubble-typing">
            <div class="dot_0 dot"></div>
            <div class="dot_1 dot"></div>
            <div class="dot_2 dot"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="input-wrap">
      <div class="dropdown btn-persistant">
        <!-- <button class="dropbtn" (click)="togglePersistancy()"></button> -->
        <div id="myPers" class="dropdown-content" [ngClass]="{'show animated pulse': persistantFlag}">
          <a *ngFor="let persistantMenu of persistantMenus"
            (click)="onClick(persistantMenu, chats.length - 1, false)">{{persistantMenu.title}}</a>
        </div>
      </div>

      <div class="form-builder">
        <form #msgForm="ngForm" novalidate (ngSubmit)="onSubmit(msgForm)">
          <!-- <textarea placeholder="Type something..." name="msg" autocomplete="off" [(ngModel)]="message" required></textarea> -->
          <input placeholder="Type keyword in English......" #chatInput name="msg" autocomplete="off"
            [(ngModel)]="message" [disabled]="inputDisabled" [ngClass]="{ 'cursor-prevent': inputDisabled}" required>
          <div class="btn-wrap">
            <!-- <div class="dropdown btn-persistant">
              <button class="dropbtn" (click)="togglePersistancy()"></button>
              <div id="myPers" class="dropdown-content" [ngClass]="{'show animated pulse': persistantFlag}">
                <a *ngFor="let persistantMenu of persistantMenus"
                  (click)="onClick(persistantMenu, chats.length - 1, false)">{{persistantMenu.title}}</a>
              </div>
            </div> -->
            <input type="file" #file style="display: none;" accept=".pdf,.jpeg,.jpg,.png,.gif"
              (change)="uploadFiles($event)">
            <button type="submit" [disabled]="inputDisabled" [ngClass]="{ 'cursor-prevent': inputDisabled}"><img
                src="assets/image/send.png"></button>
          </div>
        </form>
      </div>

    </div>

    <div *ngIf="emojiFlag" class="text-center">
      <emoji-mart [showPreview]="false"
        [exclude]="['nature', 'foods', 'activity', 'places', 'objects', 'symbols', 'flags', 'custom']"
        [style]="{ position: 'absolute', bottom: '60px', right: '10px' }" (emojiClick)="addEmoji($event)"></emoji-mart>
    </div>
  </div>

  <!-- <ng-template #welcomeTab>
    <div *ngIf="popupFlag">
      <div class="wow fadeIn popup-div" data-wow-duration="100ms" data-wow-delay="200ms">
        <div class="popup-head">
          <button id="back" class="btn-back" type="button" (click)="hidePopup()">
            <img class="imagify" src="assets/image/back.png">
          </button>
          <h6>Help Center</h6>
        </div>
        <div class="popup-cont">
          <iframe [src]="searchResultUrl"></iframe>
        </div>
      </div>
    </div>
    <div class="welcome-box-nav">

      <div class="wow bounceInUp" data-wow-duration="2s" data-wow-delay="0ms">
        <div class="title-div">
          <img [src]="homeHeaderData?.icon" alt="">
        </div>
        <h3> {{homeHeaderData?.title}} </h3>
        <p> {{homeHeaderData?.subtitle}} </p>
      </div>
    </div>

    <div id="chat" class="chat-box-content welcome-container" style="background-color: transparent;">
      <div class="freeze">
        <div #homescrollRef id="bubbleWrap" class="bubble-wrap" [scrollTop]="homeScroll">

          <div class="welcome-cards start wow fadeIn" data-wow-duration="2000ms" data-wow-delay="600ms">
            <h6 class="mb-1"> {{homechatLinkData.title}} </h6>
            <p> {{homechatLinkData.subtitle}} </p>
            <a class="btn-dark btn mt-3 btn-start" (click)="enableChat()">
              <i class="far fa-paper-plane"></i>
              {{homechatLinkData.button_text}}
            </a>
          </div>

          <div *ngIf="contentSearchFlag" class="welcome-cards">
            <h6 class="mb-2"> {{contentFormMeta?.title}} </h6>
            <form #searchForm="ngForm" novalidate (ngSubmit)="contentSearch(searchForm)">
              <div class="search-ans">
                <input type="text" class="form-control" placeholder="Search" name="term" [(ngModel)]="contentSearchData.search_phrase"
                  required pattern="(.*\S.*)" #term="ngModel">
                <button type="submit" class="btn btn-primary">
                  <img class="imageInBtn" [src]="contentFormMeta?.icon" alt="search">
                </button>
                <div *ngIf="term.errors && (term.touched || searchForm.submitted)" class="cardError">
                  <p *ngIf="term?.errors.required">This field is required</p>
                  <p *ngIf="term?.errors.pattern">Please enter a search term</p>
                </div>
              </div>
            </form>
            <div *ngIf="contentSearchResults.length" [ngClass]="{'animated zoomIn': contentSearchResults.length}">
              <h6 class="mb-2 mt-3">Find the answers for your query.</h6>
              <div class="search-list-wrap">
                <div class="search-list" *ngFor="let searchResult of contentSearchResults; let hr = index">
                  <div class="icon"><i class="far fa-list-alt"></i></div>
                  <div class="text">
                    <a (click)="showPopup(searchResult)"> {{searchResult?.title}} </a>
                    <p>{{searchResult?.description}}</p>
                  </div>
                </div>
                <a *ngIf="contentMeta.total > 3" class="moreResuls" (click)="searchResults('content', contentSearchUrl, contentSearchData)">See
                  more results</a>
              </div>
            </div>
          </div>



          <div *ngIf="homeCards.length">
            <div class="animated" [ngClass]="{'fadeInDown': homeCards.length}">
              <div *ngFor="let homeCard of homeCards; let hc = index" class="welcome-cards">
                <h6 class="mb-2"> {{homeCard?.title}} </h6>
                <a (click)="checkForUrl(homeCard)">
                  <img [src]="homeCard?.image_url" class="img-fluid mb-2" alt="">
                </a>
                <p [innerHTML]="homeCard?.subtitle"> </p>
              </div>
            </div>
          </div>

          <div *ngIf="subscriptionFlag" class="welcome-cards">
            <h6 class="mb-2"> {{subscriptionMeta?.title}} </h6>
            <form #subscribeForm="ngForm" novalidate (ngSubmit)="subscribe(subscribeForm)">
              <div class="search-ans">
                <input type="email" class="form-control" name="email" placeholder="email" [(ngModel)]="subscriptionData.email"
                  required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$" #email="ngModel">
                <button type="submit" class="btn btn-primary">
                  <img class="imageInBtn" [src]="subscriptionMeta?.icon" alt="subscribe">
                </button>
                <div *ngIf="email.errors && (email.touched || subscribeForm.submitted)" class="cardError">
                  <p *ngIf="email?.errors.required">This field is required</p>
                  <p *ngIf="email?.errors.pattern">Please enter a valid email</p>
                </div>
                <div *ngIf="subscriptionResp && subscriptionResp?.message">
                  <p *ngIf="subscriptionResp?.success"> {{subscriptionResp.message}} </p>
                  <p class="cardError" *ngIf="!subscriptionResp?.success"> {{loginResp.message}} </p>
                </div>
              </div>
            </form>
          </div>


          <div *ngIf="loginFlag" class="welcome-cards">
            <h6 class="mb-2"> {{loginMeta?.title}} </h6>
            <form #loginForm="ngForm" novalidate (ngSubmit)="login(loginForm)">
              <div class="search-ans mb5">
                <input type="text" name="username" placeholder="Username" [(ngModel)]="loginData.username" required
                  pattern="(.*\S.*)" #username="ngModel">
                <div *ngIf="username.errors && (username.touched || loginForm.submitted)" class="cardError">
                  <p *ngIf="username?.errors.required">This field is required</p>
                  <p *ngIf="username?.errors.pattern">Please enter a valid name</p>
                </div>
              </div>
              <div class="search-ans">
                <input type="password" name="password" placeholder="Password" [(ngModel)]="loginData.password" required
                  pattern="(.*\S.*)" #password="ngModel">
                <button type="submit" class="btn btn-primary">
                  <img class="imageInBtn" [src]="loginMeta?.icon" alt="login">
                </button>
                <div *ngIf="password.errors && (password.touched || loginForm.submitted)" class="cardError">
                  <p *ngIf="password?.errors.required">This field is required</p>
                  <p *ngIf="password?.errors.pattern">Please enter a valid password</p>
                </div>
                <div *ngIf="loginResp && loginResp?.message">
                  <p *ngIf="loginResp?.success"> {{loginResp.message}} </p>
                  <p class="cardError" *ngIf="!loginResp?.success"> {{loginResp.message}} </p>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="productSearchFlag" class="welcome-cards">
            <h6 class="mb-2"> {{productFormMeta?.title}} </h6>
            <form #prodSearchForm="ngForm" novalidate (ngSubmit)="productSearch(prodSearchForm)">
              <div class="search-ans">
                <input type="text" class="form-control" placeholder="Search" name="product" [(ngModel)]="productSearchData.search_product"
                  required pattern="(.*\S.*)" #product="ngModel">
                <button type="submit" class="btn btn-primary">
                  <img class="imageInBtn" [src]="productFormMeta?.icon" alt="product">
                </button>
                <div *ngIf="product.errors && (product.touched || prodSearchForm.submitted)" class="cardError">
                  <p *ngIf="product?.errors.required">This field is required</p>
                  <p *ngIf="product?.errors.pattern">Please enter a product</p>
                </div>
              </div>
            </form>
            <div *ngIf="productSearchResults.length" [ngClass]="{'animated zoomIn': productSearchResults.length}">
              <h6 class="mb-2 mt-3">Find the answers for your query.</h6>
              <div class="search-list-wrap">
                <div class="search-list" *ngFor="let product of productSearchResults; let ps = index">
                  <div class="icon"><i class="far fa-list-alt"></i></div>
                  <div class="text">
                    <a (click)="showPopup(product)"> {{product?.title}} </a>
                    <p>{{product?.description}}</p>
                  </div>
                </div>
                <a *ngIf="productMeta.total > 3" class="moreResuls" (click)="searchResults('product', productSearchUrl, productSearchData)">See
                  more results</a>
              </div>
            </div>
          </div>


        </div>
      </div>

    </div>
  </ng-template> -->
</div>